import { FC, SVGProps } from "react";

const BoltIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      <path
        d="M13.6292 2.86454L4.45188 13.1036L10.8441 13.6629L9.29181 20.8884L18.4691 10.6493L12.0769 10.0901L13.6292 2.86454Z"
      />
    </svg>
  );
};

export default BoltIcon;
